<template>
  <form class="contact-editor" @submit.prevent="submit">
    <div class="contact-editor__grid">
      <div class="contact-editor__field">
        <label class="contact-editor__label" for="contact-rut">Rut</label>
        <input
          id="contact-rut"
          v-model.trim="form.rut"
          class="contact-editor__input"
          type="text"
          placeholder="12.345.678-9"
        >
      </div>

      <div class="contact-editor__field">
        <label class="contact-editor__label" for="contact-name">Nombre</label>
        <input
          id="contact-name"
          v-model.trim="form.name"
          class="contact-editor__input"
          type="text"
          placeholder="Nombre del contacto"
        >
      </div>

      <div class="contact-editor__field">
        <label class="contact-editor__label" for="contact-phone">Telefono</label>
        <input
          id="contact-phone"
          v-model.trim="form.phone"
          class="contact-editor__input"
          type="tel"
          placeholder="+56 9 ..."
        >
      </div>

      <div class="contact-editor__field">
        <label class="contact-editor__label" for="contact-email">Email</label>
        <input
          id="contact-email"
          v-model.trim="form.email"
          class="contact-editor__input"
          type="email"
          placeholder="correo@empresa.cl"
        >
      </div>

      <div class="contact-editor__field contact-editor__field--full">
        <label class="contact-editor__toggle">
          <input v-model="form.is_primary" type="checkbox">
          <span>Marcar como contacto principal</span>
        </label>
      </div>
    </div>

    <p v-if="error" class="contact-editor__error">{{ error }}</p>

    <footer class="contact-editor__actions">
      <button class="contact-editor__ghost" type="button" :disabled="saving" @click="$emit('cancel')">
        Cancelar
      </button>

      <button class="contact-editor__primary" type="submit" :disabled="saving">
        {{ saving ? 'Guardando...' : submitLabel }}
      </button>
    </footer>
  </form>
</template>

<script>
import companyPeopleService from '@/services/company/companyPeople.service'

const defaultForm = () => ({
  id: null,
  rut: '',
  name: '',
  phone: '',
  email: '',
  is_primary: false
})

export default {
  name: 'ContactEditor',
  props: {
    value: {
      type: Object,
      default: null
    },
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      form: defaultForm(),
      saving: false,
      error: ''
    }
  },
  computed: {
    submitLabel () {
      return this.form.id ? 'Guardar cambios' : 'Crear contacto'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        this.form = {
          ...defaultForm(),
          ...(newValue || {})
        }
      }
    }
  },
  methods: {
    validate () {
      if (!this.form.name) {
        this.error = 'El nombre es obligatorio.'
        return false
      }

      if (!this.form.email && !this.form.phone) {
        this.error = 'Debes ingresar al menos email o telefono.'
        return false
      }

      this.error = ''
      return true
    },
    normalizePayload () {
      return {
        id: this.form.id,
        company_id: Number(this.companyId),
        rut: this.form.rut ? this.form.rut.replace(/\./g, '').trim() : '',
        name: this.form.name,
        phone: this.form.phone,
        email: this.form.email,
        is_primary: Boolean(this.form.is_primary)
      }
    },
    async submit () {
      if (!this.validate()) return

      this.saving = true
      this.error = ''

      try {
        const payload = this.normalizePayload()
        const saved = this.form.id
          ? await companyPeopleService.updateContact(payload)
          : await companyPeopleService.createContact(payload)

        this.$emit('saved', saved)
      } catch (err) {
        this.error = err && err.message ? err.message : 'No fue posible guardar el contacto.'
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.contact-editor {
  display: grid;
  gap: 1rem;
}

.contact-editor__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.contact-editor__field {
  display: grid;
  gap: 0.38rem;
}

.contact-editor__field--full {
  grid-column: span 2;
}

.contact-editor__label {
  color: #4b3b2f;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.contact-editor__input {
  min-height: 2.9rem;
  padding: 0.7rem 0.85rem;
  border: 1px solid rgba(102, 81, 57, 0.14);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.76);
  color: #241c16;
}

.contact-editor__toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  color: #4a3a2d;
}

.contact-editor__error {
  margin: 0;
  color: #a24444;
  font-size: 0.9rem;
}

.contact-editor__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.55rem;
}

.contact-editor__ghost,
.contact-editor__primary {
  min-height: 2.65rem;
  padding: 0 0.95rem;
  border-radius: 999px;
}

.contact-editor__ghost {
  border: 1px solid rgba(102, 81, 57, 0.12);
  background: rgba(255, 255, 255, 0.72);
  color: #392d22;
}

.contact-editor__primary {
  border: 0;
  background: linear-gradient(135deg, #251d16 0%, #4c3c2d 100%);
  color: #f7f0e5;
}

@media (max-width: 640px) {
  .contact-editor__grid {
    grid-template-columns: 1fr;
  }

  .contact-editor__field--full {
    grid-column: span 1;
  }

  .contact-editor__actions {
    flex-direction: column;
  }
}
</style>
